export const initializePendo = (options) => window?.pendo?.initialize(options);
